import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const Hero = () => {
  return (
    <section className="relative min-h-[92vh] flex items-center pt-32 pb-20 lg:pt-40 lg:pb-24 overflow-hidden">
      {/* Background video */}
      <div className="absolute inset-0 -z-10 overflow-hidden">
        <div className="absolute inset-0 w-full h-full">
          <iframe
            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none"
            style={{
              width: '100vw',
              height: '56.25vw',
              minHeight: '100vh',
              minWidth: '177.77vh'
            }}
            src="https://www.youtube.com/embed/v6-lZvvdsqs?autoplay=1&mute=1&loop=1&controls=0&showinfo=0&modestbranding=1&rel=0&iv_load_policy=3&playsinline=1&disablekb=1&fs=0&cc_load_policy=0&playlist=v6-lZvvdsqs"
            title="Background video"
            frameBorder="0"
            allow="autoplay; encrypted-media; picture-in-picture"
          />
          {/* Transparent overlay to block ALL YouTube controls/hover */}
          <div className="absolute inset-0 z-[1]"></div>
        </div>
        {/* Subtle dark overlays for text readability */}
        <div className="absolute inset-0 bg-[#0b0b0d]/35 z-[2]"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-[#0b0b0d]/85 via-[#0b0b0d]/40 to-transparent z-[3]"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#0b0b0d] via-transparent to-transparent z-[3]"></div>
      </div>

      <div className="max-w-[1440px] mx-auto px-6 lg:px-10 w-full">
        <div className="max-w-4xl">
          <p className="section-label mb-6">Full-Service Marketing Agency in Liverpool. Covering whole UK.</p>
          <h1 className="font-display text-4xl md:text-5xl lg:text-[64px] font-black leading-[1.05] text-white">
            Show people who you are. <br />
            <span className="text-[#F5CD1B]">Prove what you can do.</span> <br />
            Give them a reason to care.
          </h1>
          <p className="text-white/85 text-lg leading-relaxed max-w-2xl mt-8">
            We're <span className="text-white font-semibold">Yellow</span>, a strategic marketing partner & creative consultancy in Liverpool. Over <span className="text-white font-semibold">1,000+ projects</span> delivered for global brands, universities, the public sector and ambitious SMEs.
          </p>
          <p className="text-white text-lg font-semibold mt-6">
            We have <span className="text-[#F5CD1B]">4 services</span> to choose from:
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-5 max-w-2xl">
            <Link to="/improve-public-awareness" className="btn-yellow inline-flex items-center justify-between gap-2 px-5 py-3 rounded-md uppercase text-xs whitespace-nowrap">
              Improve public awareness <ArrowRight size={16} />
            </Link>
            <Link to="/competing-on-price" className="btn-yellow inline-flex items-center justify-between gap-2 px-5 py-3 rounded-md uppercase text-xs whitespace-nowrap">
              Stop competing on price <ArrowRight size={16} />
            </Link>
            <Link to="/losing-staff" className="btn-yellow inline-flex items-center justify-between gap-2 px-5 py-3 rounded-md uppercase text-xs whitespace-nowrap">
              Better internal comms <ArrowRight size={16} />
            </Link>
            <Link to="/public-sector" className="btn-yellow inline-flex items-center justify-between gap-2 px-5 py-3 rounded-md uppercase text-xs whitespace-nowrap">
              Public sector campaigns <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/50">
        <span className="text-[10px] uppercase tracking-[0.3em]">Scroll</span>
        <div className="w-px h-10 bg-gradient-to-b from-white/50 to-transparent"></div>
      </div>
    </section>
  );
};

export default Hero;
